<div class="row">
    <div class="col-12 text-center">
        <h2>{{ 'pages.tenants.select' | translate }}</h2>
        <p>{{ 'pages.tenants.update' | translate }}</p>
    </div>
    <div class="col-12 pt-3 text-center"> 

        <h4>{{ 'pages.tenants.current' | translate }}: {{selectedTenant}}</h4>

        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-info" id="dropdownMenu1" ngbDropdownToggle>Change tenant</button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu1">
                <button ngbDropdownItem *ngFor="let ten of availableTenants" (click)="selectTenant(confirmModal, ten)">{{ten}}</button>
            </div>
        </div>
    </div>
</div>



<ng-template #confirmModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.confirm' | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="text-align: center">
        <form>  
            <p>{{ 'pages.tenants.confirm' | translate }} <b>{{selectedTenant}}</b>?</p>
            <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="switch(); d();">Confirm</button>
                <button type="button" class="btn btn-primary" (click)="d()"> Cancel</button>
            </div>
        </form>
    </div>
</ng-template>

